<template>
	<div class="body-header">
    <div class="header-wrapper-content">
      <div class="header-wrapper">
        <img src="/static/images/header-logo.png">
      </div>
      <div class="header-operations" v-if="login">
        <div class="btn-img close" @click="closeAcountAction"><span class="iconfont icon-zhuxiao"></span> <span>{{$t('basic.close')}}</span></div>
        <div class="btn-img logout" @click="exit"><span class="iconfont icon-tuichu"></span> <span>{{$t('basic.logout')}}</span></div>
      </div>
      <div class="header-operations" v-else>
        <div class="info"><span>{{$t('index.info')}}</span></div>
      </div>
    </div>
	</div>
</template>

<script>
import Config from 'common/script/config.js'
export default {
  name: 'basicheader',
  props: ['login'],
  methods: {
    exit: function () {
      console.log('logout')
      Config.setLocalStore('request_flag', 0)
      this.$http.get(Config.passportHost + '/account/logout/').then((response) => {
        Config.cookieSet(Config.COOKIE_KEY.U_ID, '')
        Config.cookieSet(Config.COOKIE_KEY.TOKEN, '')
        Config.cookieSet(Config.COOKIE_KEY.USER_NAME, '')
        window.location.href = 'index.html?action=logout'
      })
    },
    closeAcountAction: function () {
      this.$router.push('/closeAcount')
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.body-header
  z-index 10
  background-image linear-gradient(#fafafa, #fafafa),linear-gradient(#ffffff, #ffffff)
  background-blend-mode normal, normal
  .header-wrapper-content
    display flex
    width 6.11rem
    position absolute
    bottom 0.14rem
    left 50%
    transform translateX(-50%)
  .header-operations
    height 100%
    line-height 100%
    display flex
    margin-left auto
    .info
      align-self center
      color #3d3d3d
      font-size 0.12rem
      height 0.2rem
      line-height 0.2rem
      span
        vertical-align middle !important
    .btn-img
      align-self center
      color #3d3d3d
      font-size 0.12rem
      cursor pointer
      height 0.2rem
      line-height 0.2rem
      span
        vertical-align middle !important
      .iconfont
        color #a7a7a7
      .icon-zhuxiao
        font-size 0.2rem
      &.close
        margin-right 0.29rem
.header-wrapper
  width 1.75rem
	img
		width 1.04rem
</style>



// WEBPACK FOOTER //
// header.vue?bab03dba